import * as service from "../service";
import { store } from "../../store";
import type { ServiceResponse } from "../types";

type CreateBusinessCouponPayload = {
  coupon_image: string;
  coupon_name: string;
  original_price: string;
  terms_conditions_en: string;
  terms_conditions_zh_hant: string;
  redeem_times_per_user: string;
  issued_quantity: string;
  coupon_category?: string;
  offer_type?: string;
  scan_by_qr_code?: number;
};

type BusinessCreatedCoupon = Record<string, any>;

/**
 * Create a coupon for the currently logged-in business user.
 * Backend: POST /api/coupon/businessCoupons/createCoupon
 */
export const CreateBusinessCouponAPI = async (
  payload: CreateBusinessCouponPayload,
): Promise<ServiceResponse<BusinessCreatedCoupon>> => {
  const { business } = store.getState().auth as any;
  try {
    const resp = (await service.call(
      "POST",
      "api/coupon/businessCoupons/createCoupon",
      {
        user_id: business?.user_id,
        ...payload,
      },
    )) as ServiceResponse<BusinessCreatedCoupon>;
    return resp;
  } catch (err) {
    console.error(`CreateBusinessCouponAPI ${err}`);
    return { status: -1, error: err };
  }
};
